<template>
<v-dialog
    v-if="shipments != null"
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Recent Shipments</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickCancel"
                >
                    Close
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text>

            <v-data-table
                v-if="results != null"
                :headers="headers"
                :items="results"
                :items-per-page="100"
                class="elevation-1"
                :hide-default-footer="true"
                disable-sort
                :footer-props="{
                    disableItemsPerPage: false,
                    disablePagination: false,
                }"
                style="margin-top: 15px"
            >
                <template v-slot:item.first_event_time_date="{ item }">
                    {{$rc.pretty(item.first_event_time,'date')}}
                </template>

                <template v-slot:item.first_event_time_time="{ item }">
                    {{$rc.pretty(item.first_event_time,'time')}}
                </template>
            
                <template v-slot:item.tracking_number="{ item }">
                    <span class="tracking_number">
                        <a
                            v-on:click="onClickTrackingNumber(item)"
                        >
                            {{item.tracking_number}}
                        </a>
                    </span>
                </template>

                <template v-slot:item.last_event_time_date="{ item }">
                    {{$rc.pretty(item.last_event_time,'date')}}
                </template>

                <template v-slot:item.last_event_time_time="{ item }">
                    {{$rc.pretty(item.last_event_time,'time')}}
                </template>

                <template v-slot:item.action="{ item }">
                    <v-menu 
                        bottom 
                        offset-y  
                    >
                    
                    <template v-slot:activator="{ on }">
                            
                        <v-icon 
                            v-on="on"
                        >
                            mdi-dots-vertical-circle-outline
                        </v-icon>
                            
                    </template>
                    
                    <v-list>
                        <v-list-item
                            v-on:click="onClickCopyTrackingNumber(item)"
                        >
                            <v-list-item-title>Copy Tracking Number...</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-on:click="onClickTrackingNumber(item)"
                        >
                            <v-list-item-title>Track Package...</v-list-item-title>
                        </v-list-item>

                        <v-divider
                            v-if="item.is_redirect_available && $rc.$state.isAuthActorSystemAdmin()"
                        />

                         <v-list-item
                            v-if="item.is_redirect_available && $rc.$state.isAuthActorSystemAdmin()"
                            v-on:click="onClickRedirectPackage(item)"
                        >
                            <v-list-item-title>Redirect Package...</v-list-item-title>
                        </v-list-item>
                    
                    </v-list>
                    
                    </v-menu> 
                </template>
            
            </v-data-table>

        </v-card-text>

    </v-card>

    <m-message-redirect-package-dialog
        ref="dialog-redirect"
    />

</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            dialog: false,
            last_dialog_guard: null,
            shipments: null,

            headers: [
                { text: 'First Event (Date)', value: 'first_event_time_date'},
                { text: 'First Event (Time)', value: 'first_event_time_time'},

                { text: 'Tracking Number', value: 'tracking_number'},

                { text: 'Most Recent Event', value: 'last_event_type'}, 
                { text: 'Most Recent Event (Date)', value: 'last_event_time_date'},
                { text: 'Most Recent Event (Time)', value: 'last_event_time_time'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    methods: {

        showDialog(shipments)
        {
            this.shipments = _.cloneDeep(shipments);
            this.dialog = true;
            this.last_dialog_guard = this.$router.dialog_guard;
            this.$router.dialog_guard = this.dialogGuard;
        },

        closeDialog()
        {
            this.dialog = false;
            this.shipments = null;
            this.$router.dialog_guard = this.last_dialog_guard;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.closeDialog();
                return;
            }
        
            this.closeDialog();
            next(false);
        },

        onClickCancel()
        {
            this.closeDialog();
        },

        onClickTrackingNumber(item)
        {
            window.open(item.tracking_url, '_blank');
        },

        onClickCopyTrackingNumber(item)
        {
            this.$rc.copy(item.tracking_number);
        },

        onClickRedirectPackage(item)
        {
            this.$refs['dialog-redirect'].showDialog(item);
        },
    },

    computed: {
        results() {
            if ( this.shipments == null ) return [];

            return this.shipments;
        }
    },
}
</script>

<style lang="scss" scoped>
.tracking_number {
    font-family: monospace;
    text-decoration: underline;
}
</style>